angular.module('iqxCore')
  .controller('PayDocumentsCtrl', function ($scope, $routeParams, FormSvc, SweetAlert) {
    FormSvc.setOptions($scope, { notLoggedIn: true, autoEdit: true, dateFields: ['DOB'] })
    FormSvc.setEditing($scope, true)
    $scope.dateOptions.datepickerMode = 'year'
    $scope.dateOptions.initDate = moment().subtract('30', 'y').toDate()

    $scope.$parent.forceHideSidebarMenu = true
    $scope.showError = false
    $scope.showForm = false
    $scope.payDoc = {}
    $scope.theRecord = {}

    $scope.showErrorMsg = function (type) {
      $scope.showError = true
      type = type || 1
      SweetAlert.swal({
        title: $scope.params.lang.pages.payDocuments.documentNotFound.title,
        text: $scope.params.lang.pages.payDocuments.documentNotFound.message + ' [' + type + ']',
        type: 'error'
      })
    }

    // Deal with branding
    var iconExists = function (icon) {
      if (icon) {
        var url = '/assets/' + icon
        var request = new XMLHttpRequest()
        request.open('HEAD', url, false)
        request.send()
        if (request.status == 200 && request.responseURL.includes('.png')) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }

    $scope.brandingLogoFile = $scope.params.customLogoFile ? $scope.params.customLogoFile : $scope.params.LOGOFILE
    if ($routeParams.accountcode) {
      if (iconExists('paydocuments_' + $routeParams.accountcode + '.png')) {
        $scope.brandingLogoFile = '/paydocuments_' + $routeParams.accountcode + '.png'
      } else {
        $scope.brandingLogoFile = null
      }
    }

    if (typeof $routeParams.refid === 'undefined' || $routeParams.refid === '') {
      $scope.showErrorMsg()
    } else {
      $scope.payDoc = {
        UPKey: Number($routeParams.refid.substring(0, 10)),
        URLKey: $routeParams.refid.substring(10, 1000)
      }

      if (isNaN($scope.payDoc.UPKey)) {
        $scope.showErrorMsg()
      }

      if ($scope.payDoc.URLKey === '' || $scope.payDoc.URLKey.length < 20) {
        $scope.showErrorMsg()
      }

      if ($scope.showError !== true) {
        $scope.showForm = true
      }
    }

    $scope.submitDOB = function () {
      if ($scope.theRecord.DOB) {
        return $scope.exec('call_/NetGetAccordPayslip', {
          pDOB: moment($scope.theRecord.DOB).format('YYYY-MM-DD'),
          pUPKey: $scope.payDoc.UPKey,
          pURLKey: $scope.payDoc.URLKey
        })
          .then(function (res) {
            if (res.IQXResult.attrs.success === '1') {
              // Wont work on IE!
              var link = document.createElement('a')
              link.download = res.IQXResult.IQXSuccess.attrs.message
              link.href = 'data:application/octet-stream;base64,' + res.IQXResult.IQXSuccess.attrs.id
              link.click()
              $scope.showForm = false
              SweetAlert.swal({
                title: $scope.params.lang.pages.payDocuments.thanksForDownloading.title,
                html: $scope.params.lang.pages.payDocuments.thanksForDownloading.message,
                type: 'success'
              })
              return true
            } else {
              $scope.showErrorMsg(2)
            }
          })
          .catch(function (e) {
            $scope.showErrorMsg(2)
            $scope.theRecord.DOB = null
          })
      } else {
        SweetAlert.swal({
          title: 'Invalid Date of Birth',
          text: '',
          type: 'error'
        })
      }
    }
  })
